import { FormikErrors } from 'formik'

import { MAX_SUM_LOSES } from '../../_utils/environmentConst.provider'
import {
  biggerThanZero,
  lowerOrEqualThan,
  onlyNumber,
  required,
} from '../../_utils/formValidators'
import { PreviousInsurancesValues } from './PreviousInsurances.view'

const validateClaimsField = (formValueFields: PreviousInsurancesValues) => {
  const { numberOfClaims, prevDamages } = formValueFields
  if (prevDamages) {
    return (
      required.default(numberOfClaims.toString()) ||
      onlyNumber.default(numberOfClaims) ||
      biggerThanZero.default(numberOfClaims) ||
      lowerOrEqualThan.default(numberOfClaims, 5)
    )
  }
  return ''
}

const validateClaimLosesField = (formValueFields: PreviousInsurancesValues) => {
  const { claimLoses, prevDamages } = formValueFields
  if (prevDamages) {
    return (
      onlyNumber.default(claimLoses) ||
      biggerThanZero.default(claimLoses) ||
      lowerOrEqualThan.default(claimLoses, MAX_SUM_LOSES)
    )
  }
  return ''
}

const validateYearField = (formValueFields: PreviousInsurancesValues) => {
  const { years, prevDamages } = formValueFields
  if (prevDamages) {
    return (
      required.default(years.toString()) ||
      onlyNumber.default(years) ||
      biggerThanZero.default(years)
    )
  }
  return ''
}

export const validateFieldForm = (
  formValueFields: PreviousInsurancesValues,
) => {
  const errors: FormikErrors<PreviousInsurancesValues> = {}

  if (validateClaimsField(formValueFields)) {
    errors.numberOfClaims = validateClaimsField(formValueFields)
  }

  if (validateClaimLosesField(formValueFields)) {
    errors.claimLoses = validateClaimLosesField(formValueFields)
  }

  if (validateYearField(formValueFields)) {
    errors.years = validateYearField(formValueFields)
  }

  return errors
}
